module.exports = __webpack_public_path__ + "img/Workflows.ad4a14c6.svg";